export const LEADS_BASE_URL = '/leads';

/** Fallback icon by slug when no custom icon is set (e.g. for new admin-added types). */
export const STAKEHOLDER_ICONS: Record<string, string> = {
  electrical: '⚡',
  mechanical: '⚙️',
  plumbing: '🔧',
  general_contractor: '🏗️',
  architect_engineer: '📐',
  property_management: '🏢',
  developer_owner: '💼',
};

export const CAPTURE_METHOD_LABELS: Record<string, string> = {
  snap_card: 'Snap Card',
  upload_image: 'Upload Image',
  manual_entry: 'Manual Entry',
  bulk_upload: 'Bulk Upload',
};

export const TEMPERATURE_LABELS: Record<string, string> = {
  hot: 'Hot — Ready to talk',
  warm: 'Warm — Interested',
  cold: 'Cold — Just met',
};
